<script setup>
import { useDialogStore } from '@/stores/dialogStore';
const dialogStore = useDialogStore();
</script>

<template>
  <div class="popup-text fadein" :class="{ small: dialogStore.small, dark: dialogStore.dark }"
    v-if="dialogStore.isDialogVisible">
    <div class="popup-content">
      <button class="close" type="button"><span class="material-symbols-outlined"
          @click="dialogStore.onNegativeClick">close</span></button>
      <slot name="top"></slot>
      <div class="popup-title">
        <span class="material-symbols-outlined" v-if="dialogStore.alert">warning</span>
        {{ dialogStore.title }}
      </div>
      <div class="popup-body scroller">
        <div v-html="dialogStore.content"></div>
      </div>
      <div class="popup-action">
        <button type="button" @click="dialogStore.onNegativeClick" class="input-cancel"
          v-if="dialogStore.showNegativeButton">{{
            dialogStore.negativeButtonText
          }}</button>
        <button type="button" @click="dialogStore.onPositiveClick" class="input-submit"
          :style="{ backgroundColor: !dialogStore.alert ? 'var(--active-color)' : 'var(--alert-color)' }"> {{
            dialogStore.positiveButtonText
          }}</button>
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped></style>
